<template>
  <div class="product">
    <div class="head">
      <p class="title">民用产品</p>
      <p class="sub-title">Civilian Products</p>
      <div class="children">
        <div
          class="one"
          :class="{ active: opt == index }"
          @click="$router.push({ path: '/product', query: { index: index } })"
          v-for="(item, index) in list"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <div class="wrap">
      <div v-show="$route.path == '/product'">
        <p class="title">{{ list[opt].name }}</p>
        <!-- <p class="sub-title">{{list[opt].ex_title}}</p> -->
        <div class="inner">
          <div
            class="products"
            v-for="(item, index) in productList"
            :key="index"
            :style="{ marginRight: (index + 1) % 3 == 0 ? '0' : '20px' }"
            @click="
              $router.push({ path: '/product/detail', query: { id: item.id } })
            "
          >
            <div class="top">
              <img :src="item.image" alt srcset />
            </div>
            <div class="bottom">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { classe, productList } from '../assets/js/api'
export default {
  data() {
    return {
      opt: 0,
      list: [],
      productList: [],
    }
  },
  watch: {
    '$route.query.index': {
      handler(e) {
        if (this.$route.path == '/product') {
          this.opt = e
        }
      },
      deep: true,
    },
    opt() {
      this.getData()
    },
    '$route.query.id': {
      handler(e) {
        this.getclasse()
      },
      deep: true,
    },
    '$route.query.idx': {
      handler(e) {
        this.getData()
      },
      deep: true,
    },
  },
  created() {
    this.getclasse()
  },
  methods: {
    getclasse() {
      classe().then((r) => {
        this.list = r.data.data
        let id = this.$route.query.idx || this.$route.query.id
        if (id) {
          r.data.data.forEach((val, index) => {
            if (val.id == id) {
              this.opt = index
            }
          })
        }
        this.getData()
      })
    },
    getData() {
      productList({
        limit: 9999,
        page: 1,
        where: {
          classe_id: this.list[this.opt].id,
        },
      }).then((r) => {
        this.productList = r.data.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  height: 580px;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('../assets/img/product_banner.png');
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title {
    font-size: 42px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }

  .sub-title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }

  .children {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    width: 100%;

    & > div {
      width: 200px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.78);
      border-top: 1px solid rgba(255, 255, 255, 0.5);
      margin-right: 10px;
      cursor: pointer;
      text-decoration: none;
    }

    & > div.active {
      background: #126fcc;
      border: none;
    }
  }
}

.wrap {
  padding: 90px 0;
  background-color: #f3f2f2;

  .title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
    text-align: center;
  }

  .sub-title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
    text-align: center;
    margin-bottom: 60px;
  }

  .inner {
    display: flex;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;

    .products {
      width: 386px;
      height: 290px;
      margin-bottom: 20px;
      cursor: pointer;
      transition: all 0.15s linear;

      .top {
        width: 100%;
        height: 240px;
        border: 1px solid rgba(242, 242, 242, 1);
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 221px;
          height: 172px;
          object-fit: cover;
          transition: all 0.3s linear;
        }
      }

      .bottom {
        transition: all 0.3s linear;
        width: 100%;
        height: 50px;
        text-align: center;
        background: rgba(233, 233, 234, 1);
        line-height: 50px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }
    }

    .products:hover {
      background: #e7e6eb;

      .top {
        img {
          transform: scale(1.2) translateY(-50px);
        }
      }

      .bottom {
        background: #0e6cb6;
        color: #ffffff;
      }
    }
  }
}
</style>
